// extracted by mini-css-extract-plugin
export var homepageGalleriesHolder = "HomepageGalleries-module--homepageGalleriesHolder--TQDNP";